import React from 'react';

const FreightCalculatorModule = () => {
  return (
    <div className="module-card logistics-module">
      <div className="module-header">
        <div className="module-icon">
          <i className="fas fa-truck-moving"></i>
        </div>
        <h3>Freight Calculator</h3>
      </div>
      <div className="calculator-mini-form freight-flow">
        <div className="form-field-mini">
          <label>Loading Station</label>
          <input
            type="text"
            placeholder="Enter loading station"
            readOnly
            disabled
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed', opacity: 0.7 }}
          />
        </div>
        <div className="form-field-mini">
          <label>Unloading Station</label>
          <input
            type="text"
            placeholder="Enter unloading station"
            readOnly
            disabled
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed', opacity: 0.7 }}
          />
        </div>
        <div className="form-field-mini">
          <label>Quantity (Optional)</label>
          <input
            type="text"
            placeholder="Enter quantity"
            readOnly
            disabled
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed', opacity: 0.7 }}
          />
        </div>
        <div className="coming-soon-message" style={{ 
          marginTop: '20px', 
          padding: '15px', 
          textAlign: 'center',
          backgroundColor: '#fff3cd',
          borderRadius: '5px',
          border: '1px solid #ffc107'
        }}>
          <i className="fas fa-clock" style={{ fontSize: '24px', color: '#ffc107', marginBottom: '10px' }}></i>
          <h4 style={{ margin: '10px 0', color: '#856404' }}>Coming Soon</h4>
          <p style={{ margin: 0, color: '#856404', fontSize: '14px' }}>Our freight calculator is under development. We'll be launching it soon!</p>
        </div>
        <button
          type="button"
          className="btn-calculate"
          disabled
          style={{ 
            marginTop: '15px', 
            width: '100%',
            opacity: 0.6,
            cursor: 'not-allowed'
          }}
        >
          Calculate Freight
        </button>
      </div>
    </div>
  );
};

export default FreightCalculatorModule;

